
import VueRouter from 'vue-router';
import Home from '../home';
import Login from '../tools/loginPage.vue';
import Information from '../components/information';
import Question from '../components/userQuestion';
import UsersList from '../components/userslist';
import CompanyList from '../components/companylist';
import reportsTable from '../components/reportsTable';

const routes = [
  { path: '/', component: Home, meta: { requiresAuth: true } },
  { path: '/adminlogin', component: Login },
  { path: '/userslist', component: UsersList, meta: { requiresAuth: true } },
  { path: '*', redirect: '/adminlogin' },
  /*---------------------------👇 REQUIRES SUPER ADMIN 👇----------------------------*/
  { path: '/companylist', component: CompanyList, meta: { requiresAuth: true, requiresSuperAdmin: true } },
  { path: '/information', component: Information, meta: { requiresAuth: true, requiresSuperAdmin: true } },
  { path: '/questionandrequest', component: Question, meta: { requiresAuth: true, requiresSuperAdmin: true } },
  { path: '/reportsTable', component: reportsTable, meta: { requiresAuth: true, requiresSuperAdmin: true } }
]

export const router = new VueRouter({
  mode: 'history',
  routes
})